<template>
  <div
    class="w-full py-24"
    :style="{
      backgroundColor: `#${primaryColor}`,
    }"
  >
    <div class="h-full grid grid-cols-3 px-8 lg:px-[16rem] 2xl:px-[32rem]">
      <img
        v-if="config.footer?.logo_url"
        class="h-24 w-32 object-contain"
        :src="config.footer?.logo_url"
        alt="Logo"
      >
      <img
        v-else-if="isPreview()"
        class="h-24 w-32 object-contain"
        src="https://placehold.co/160x50"
        alt="Logo"
      >

      <div
        v-for="(page, index) in pages"
        :key="index"
        class="flex justify-center"
      >
        <p
          class="hover:underline cursor-pointer font-bold text-lg text-white my-auto"
          @click="router.get(pageUrl('CO-REG-LANDER-001', page.slug))"
        >
          {{ page.title }}
        </p>
      </div>
    </div>
  </div>

  <div class="w-full bg-black">
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="text-white text-center w-full p-4"
      v-html="config.footer?.text"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script setup>
import {ref} from 'vue';
import {router} from '@inertiajs/vue3';
import {isPreview, pageUrl} from '@timon/js/Mixins/helpers';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },

  pages: {
    type: Array,
    required: true,
  },

  collectorFlowUuid: {
    type: String,
    required: true,
  },
});

const primaryColor = ref(props.config.style?.primary);
</script>
